import { Role } from 'src/classes/Firebase';
import { RouteRecordRaw } from 'vue-router';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      {
        path: '',
        component: () => import('pages/IndexPage.vue'),
        name: 'Home',
      },
      {
        path: 'invite',
        component: () => import('pages/InvitePage.vue'),
        name: 'Invite',
      },
      {
        path: 'profile',
        component: () => import('pages/ProfilePage.vue'),
        name: 'Profile',
      },
      {
        path: 'firebase-admin',
        component: () => import('pages/firebase-admin/MainPage.vue'),
        name: 'FirebaseAdmin',
        meta: {
          roles: new Set([Role.ADMIN]),
        },
        children: [
          {
            path: 'user',
            component: () => import('pages/firebase-admin/UsersPage.vue'),
            name: 'FirebaseAdminUser',
          },
        ],
      },
      {
        path: 'matchbox',
        component: () => import('pages/matchbox/MainPage.vue'),
        name: 'Matchbox',
        meta: {
          roles: new Set([Role.ADMIN, Role.PROFESSIONAL_MATCHBOX]),
          breadcrumb: 'main',
          breadcrumbIcon: 'fas fa-car',
        },

        children: [
          {
            path: '',
            component: () => import('pages/matchbox/Tiles.vue'),
            name: 'MatchboxTiles',
            meta: {
              breadcrumb: 'tiles',
              breadcrumbIcon: 'widgets',
            },
          },
          {
            path: 'master',
            component: () => import('pages/matchbox/master/MainPage.vue'),
            name: 'MatchboxMaster',
            meta: {
              breadcrumb: 'master.main',
              breadcrumbIcon: 'fas fa-web-awesome',
            },
            children: [
              {
                path: '',
                component: () => import('pages/matchbox/Tiles.vue'),
                name: 'MatchboxMasterTiles',
                meta: {
                  breadcrumb: 'tiles',
                  breadcrumbIcon: 'widgets',
                },
              },
              {
                path: 'data',
                component: () =>
                  import('pages/matchbox/master/DataManager.vue'),
                name: 'MatchboxMasterDataManager',
                meta: {
                  breadcrumb: 'master.masterData',
                  breadcrumbIcon: 'fas fa-database',
                },
              },
              {
                path: 'tires',
                component: () =>
                  import('pages/matchbox/master/TireManager.vue'),
                name: 'MatchboxMasterTireManager',
                meta: {
                  breadcrumb: 'master.tires',
                  breadcrumbIcon: 'svguse:/tile_icons.svg#pilopsoft-wheel',
                },
              },
              {
                path: 'palette',
                component: () =>
                  import('pages/matchbox/master/PaletteManager.vue'),
                name: 'MatchboxMasterPaletteManager',
                meta: {
                  breadcrumb: 'master.palette',
                  breadcrumbIcon: 'fas fa-palette',
                },
              },
              {
                path: 'series',
                component: () =>
                  import('pages/matchbox/master/SeriesManager.vue'),
                name: 'MatchboxMasterSeriesManager',
                meta: {
                  breadcrumb: 'master.series',
                  breadcrumbIcon: 'sym_o_graph_2',
                },
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '/confirm',
    component: () => import('src/layouts/ConfirmLayout.vue'),
    children: [
      {
        path: 'firebase',
        component: () => import('pages/confirm/ConfirmFirebase.vue'),
        name: 'ConfirmFirebase',
        meta: {
          public: true,
        },
      },
    ],
  },
  {
    path: '/login',
    component: () => import('layouts/LoginLayout.vue'),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import('pages/LoginPage.vue'),
      },
    ],
  },

  {
    path: '/not-authorized',
    component: () => import('pages/NotAuthorized.vue'),
    name: 'NotAuthorized',
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
